const ANALYTICS_PLACEHOLDER_VALUES = new Set([
  'changeme',
  'empty',
  'null',
  'placeholder',
  'todo',
  'undefined',
]);

export function normalizeAnalyticsConfigValue(value: string | undefined) {
  const normalized = value?.trim() ?? '';
  if (
    !normalized ||
    ANALYTICS_PLACEHOLDER_VALUES.has(normalized.toLowerCase())
  ) {
    return null;
  }
  return normalized;
}
